define('TescoMobile_Customer/js/view/account/populate-graphs',['jquery', 'domReady!'], function ($) {
  'use strict';

  return function () {
    $('.progress-bar').each(function (i) {
      const percentage = $(this).attr('aria-value') / $(this).attr('aria-valuemax') * 100;
      $(this).css('width', percentage + '%');
    });
  };
});

